module.exports = __webpack_public_path__ + "img/campaign-logo.a498208.svg";